import anime from 'animejs';
import { dismissedOrNotApplicable } from './mobile-notice';

(() => {
	if (!dismissedOrNotApplicable()) return;

	const header = document.querySelector<HTMLElement>('[data-header]');
	if (!header) return;

	const heading = document.querySelector<HTMLElement>('[data-heading]');
	if (!heading) return;

	/**
	 * Separate the text nodes in the heading into individual span elements
	 */
	let wordsbeforeLogo = 0;
	let newHeading: ChildNode[] = [];
	heading.childNodes.forEach((node, i) => {
		if (i === 0 && node.nodeType === Node.TEXT_NODE) {
			const words = node.textContent?.trim().split(' ');
			if (!words) return;

			wordsbeforeLogo = words.length;
			words.forEach((word) => {
				const wordNode = document.createElement('span');
				wordNode.innerText = `${word}`;
				wordNode.style.display = 'inline-block';
				newHeading.push(wordNode);
				newHeading.push(document.createTextNode(' '));
			});
		} else if (node.nodeType === Node.TEXT_NODE && node.textContent !== null) {
			const span = document.createElement('span');
			span.innerText = `${node.textContent}`;
			span.style.display = 'inline-block';
			newHeading.push(span);
		} else {
			newHeading.push(node);
		}
	});

	while (heading.firstChild) {
		heading.removeChild(heading.firstChild);
	}
	heading.append(...newHeading);

	/**
	 * Start on the animation
	 */

	const initialDelay = 300;
	const delayStep = 400;
	const duration = 350;

	const followingDelayStep = 250;

	anime({
		targets: heading.querySelectorAll('*'),
		opacity: [0, 1],
		translateY: ['0.5rem', '0rem'],
		easing: 'easeOutCubic',
		duration,
		delay: (_, i) => initialDelay + i * delayStep,
	});

	anime({
		targets: document.querySelectorAll('[data-animate-bottom-bar]'),
		opacity: [0, 1],
		translateY: ['0.5rem', '0rem'],
		easing: 'easeOutCubic',
		duration,
		delay: initialDelay + followingDelayStep * (wordsbeforeLogo + 3),
	});

	anime({
		targets: header.querySelectorAll('[data-animate-last]'),
		opacity: [0, 1],
		translateY: ['0.5rem', '0rem'],
		easing: 'easeOutCubic',
		duration,
		delay: (_, i) =>
			initialDelay + followingDelayStep * (i + wordsbeforeLogo + 4),
	});

	const scrollMessage = header.querySelector('[data-animate-scroll]');
	anime({
		targets: scrollMessage,
		opacity: [0, 1],
		translateY: ['0.5rem', '0rem'],
		easing: 'easeOutCubic',
		duration,
		delay: 4400,
	});

	if (scrollMessage) {
		let hasScrolled = false;
		const handleScroll = () => {
			if (!hasScrolled && window.scrollY > 10) {
				scrollMessage.addEventListener('animationend', () => {
					scrollMessage.parentNode?.removeChild(scrollMessage);
				});
				scrollMessage.classList.add('page-header__scroll-message--dismissed');
				window.removeEventListener('scroll', handleScroll);

				hasScrolled = true;
			}
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
	}
})();
